import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

const DetailSolution: any = (props: any) => {
  const { pageData } = props;

  const formatedText = (requiredText: string) => {
    const text = requiredText;
    const alteredText = text?.replace(/\n/g, "<br />");
    return alteredText;
  };

  return (
    <Box
      pt={2}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mt: 4,

        zIndex: 1,
        position: "relative",

        backgroundPosition: "inherit",

        width: "100%",
      }}
    >
      <Grid
        container
        sx={{
          flexGrow: 1,
          display: "flex",
          alignItems: "center",
          width: "100%",
          padding: { xs: "5px", sm: "5px", md: "0px" },
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Grid
          size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
          sx={{
            order: { xs: 0, md: 0 },
            paddingBottom: { xs: "20px", md: 0 },
            position: "relative",
            display: "flex",
            alignSelf: "self-start",
          }}
        >
          <Paper
            sx={{
              padding: {
                lg: "0px 30px 0px 130px",
                md: "0px 30px 0px 100px",
                sm: "0px 30px 0px 30px",
                xs: "0px 30px 0px 30px",
              },
              background: "none",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              className="stonehand-primary fw-700"
              sx={{
                fontSize: { xs: 32, sm: 32, md: 40 },
                lineHeight: 1.6,
                textAlign: { xs: "center", md: "center" },
                flex: 1,
              }}
            >
              {
                pageData?.solutionsDetails?.blogBlock3.leftSideContent
                  ?.mainTitle
              }
            </Typography>
            <Typography
              dangerouslySetInnerHTML={{
                __html: formatedText(
                  pageData?.solutionsDetails?.blogBlock3.leftSideContent
                    ?.subTitle
                ),
              }}
              sx={{
                fontWeight: 400,
                fontSize: "18px",
                textAlign: { xs: "center", md: "center" },
              }}
            ></Typography>
          </Paper>
        </Grid>
        {/* Image section - Now on the left */}
        <Grid
          size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
          sx={{
            position: "relative",
            display: "flex",
            paddingBottom: { xs: "20px", md: 0 },
            justifyContent: "center",
            alignItems: "center",
            order: { xs: 0, md: 0 }, // Changed order for md and larger screens
          }}
        >
          <TableContainer
            component={Box}
            sx={{
              width: "100%",
              margin: "auto",
              paddingBottom: { xs: 5, sm: 5, lg: 3, md: 3, xl: 3 },
              overflowX: "hidden",
            }}
          >
            <Table sx={{ width: "100%" }} aria-label="highlightable rows table">
              <TableBody>
                {pageData?.solutionsDetails?.blogBlock3.rightSideContent?.block4row.map(
                  (row: any, index: any) => {
                    const dimFactor = Math.max(1 - index * 0.2, 0);
                    return (
                      <TableRow
                        key={row.id}
                        sx={{
                          padding: {
                            xs: "5px 0px 5px 13px",
                            md: "20px 0px 20px 20px",
                            lg: "20px 0px 20px 20px",
                            sm: "5px 0px 5px 13px",
                            xl: "20px 0px 20px 20px",
                          },
                          flexDirection: {
                            xs: "column",
                            md: "row",
                            sm: "column",
                            lg: "row",
                          },
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: "-100%",
                            width: "100%",
                            height: "100%",
                            background: ` linear-gradient(90deg, rgba(26, 134, 233, 0.8) 0%, rgba(76, 199, 188, 0.8) 100%)`,
                            zIndex: 0,
                            transition: "left 0.75s ease-in-out",
                          },
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "flex-start",
                          color: "#fff",
                          borderBottom: "none",
                          position: "relative",
                          overflow: "hidden",
                          background: `linear-gradient(90deg, rgba(76, 199, 188, ${dimFactor}) 0%, rgba(26, 134, 233, ${dimFactor}) 100%)`,
                          width: "100%",
                          cursor: "pointer",

                          "&:hover::before": {
                            left: "0%",
                          },
                          "& *": {
                            position: "relative",
                            zIndex: 1,
                          },
                        }}
                      >
                        <TableCell
                          sx={{
                            width: "100%",
                            padding: 1,
                            display: "flex",
                            alignItems: "flex-start",
                            borderBottom: "none",
                            color: "#fff",
                          }}
                          className="sh-statistic-table-cell"
                        >
                          <Typography
                            className="fw-500"
                            sx={{
                              textWrap: "wrap",
                              fontWeight: 600,
                              width: "100%",
                            }}
                          >
                            {row.description}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    );
                  }
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DetailSolution;
